interface DownloadArgs {
  fileName: string;
  data: BlobPart;
  headers: Record<string, string>;
}

export default () => {
  return ({ fileName, data, headers }: DownloadArgs) => {
    const blob = new Blob([data], {
      type: headers['content-type'],
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    // Release the object URL and detach the node once the download has kicked
    // off, so repeated downloads don't leak blobs/DOM nodes.
    setTimeout(() => {
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    }, 0);
  };
};
